/* eslint-disable import/no-cycle */
import { fetchManagerPerformanceForHome } from "apis/manager";
import { put, takeEvery } from "redux-saga/effects";
import { enqueueSnackbar } from "notistack";
import { managerAction } from "../slice/manager";

export function* getManagerPerformance(action) {
  try {
    if (!action?.payload?.teams?.length) {
      yield put(
        managerAction.getManagerPerformance({
          data: [],
        })
      );
    } else {
      const info = yield fetchManagerPerformanceForHome(action.payload);

      if (info?.data?.success) {
        yield put(
          managerAction.getManagerPerformance({
            data: info.data.data,
            streakData: info.data.streakData,
          })
        );
      } else if (info?.response?.status !== 403) {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text: info?.response?.data?.message || "Something went wrong",
          }),
          {
            variant: "custom",
          }
        );
        yield put(managerAction.getManagerPerformanceFail());
      }
    }
  } catch (error) {
    enqueueSnackbar(
      JSON.stringify({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error.message || "Something went wrong",
      }),
      {
        variant: "custom",
      }
    );
    yield put(managerAction.getManagerPerformanceFail());
  }
}

export function* watchManagerAsync() {
  yield takeEvery(managerAction.getManagerPerformanceSaga, getManagerPerformance);
}
